<template>
  <div class="text-center">
    <h1 class="title">Page Not Found</h1>
    <div class="container-fluid container-lg">
      <div class="alert alert-danger my-3 mx-2">
        <h2>Sorry. Page Not Found</h2>
        <p>Go back to Home to navigate between Events</p>
      </div>
    </div>
  </div>
</template>
                                              
<script>
export default {
  name: 'NotFound',
}
</script>
                                              
<style scoped>
</style>